import { $, $$ } from '@zimpa/dom';

const WIZARD_SELECTOR = '.js-report-wizard';
const CONTAINER_SELECTOR = '.js-report-wizard__question';
const NEXT_BUTTON_SELECTOR = '.js-report-wizard__next';
const RESET_BUTTON_SELECTOR = '.js-report-wizard__reset';
const DATA_TARGET_SELECTOR = '[data-target]';
const RESULT_SELECTOR = '.js-report-wizard__question__result';
const QUESTION_SELECTOR = '.js-report-wizard__question';
const STEP_SELECTOR = '.js-report-wizard__step';
const CHECKBOX_SELECTOR = '.js-report-wizard__check';
const COLLAPSED_CLASS = 'h-collapsed';
const HIDE_CLASS = 'h-hide';
const NAVIGATION_INDICATOR_SELECTOR =
    '.js-report-wizard__navigation--indicator';
const NAVIGATION_ACTIVE_CLASS = 'c-report-wizard__navigation--step--active';
const NAVIGATION_DONE_CLASS = 'c-report-wizard__navigation--step--done';

class ReportWizard {
    public constructor(wizard: HTMLSelectElement) {

        $$(RESET_BUTTON_SELECTOR, wizard).forEach((resetButton) => {
            resetButton.addEventListener('click', (event) => {
                event.preventDefault();

                $$(RESULT_SELECTOR, wizard).forEach((item) => {
                    item.classList.add(COLLAPSED_CLASS);
                });

                $$(QUESTION_SELECTOR, wizard).forEach((item) => {
                    item.classList.remove(COLLAPSED_CLASS);
                });

                $$(CHECKBOX_SELECTOR, wizard).forEach(
                    (item: HTMLInputElement) => {
                        item.checked = false;
                    },
                );

                $$(STEP_SELECTOR, wizard).forEach((item, index) => {
                    if (index !== 0) {
                        item.classList.add(COLLAPSED_CLASS);
                    } else {
                        item.classList.remove(COLLAPSED_CLASS);
                    }
                });

                //AS: reset navigation
                $$(NAVIGATION_INDICATOR_SELECTOR, wizard).forEach(
                    (item, index) => {
                        item.classList.remove(NAVIGATION_ACTIVE_CLASS);
                        item.classList.remove(NAVIGATION_DONE_CLASS);
                        if (index === 0) {
                            item.classList.add(NAVIGATION_ACTIVE_CLASS);
                        }
                    },
                );
            });
        });

        $$(CONTAINER_SELECTOR, wizard).forEach((container) => {
            const nextButton = $<HTMLElement>(NEXT_BUTTON_SELECTOR, container);
            if (nextButton === undefined) {
                return;
            }

            nextButton.addEventListener('click', (event) => {
                event.preventDefault();
                const nextStep = nextButton.getAttribute('data-activate-step');
                $$(DATA_TARGET_SELECTOR, container).forEach(
                    (item: HTMLElement) => {
                        const id = item.getAttribute('data-target');
                        if (id === null) {
                            return;
                        }
                        const target = $<HTMLElement>(id, wizard);
                        const checkBox = $<HTMLInputElement>(
                            CHECKBOX_SELECTOR,
                            item,
                        );

                        if (checkBox !== undefined && checkBox.checked) {
                            target?.classList.remove(COLLAPSED_CLASS);
                            container.classList.add(COLLAPSED_CLASS);

                            if (nextStep !== null) {
                                $$(
                                    NAVIGATION_INDICATOR_SELECTOR,
                                    wizard,
                                ).forEach((item, index) => {
                                    if (index === parseInt(nextStep)) {
                                        item.classList.add(
                                            NAVIGATION_ACTIVE_CLASS,
                                        );
                                    } else if (index < parseInt(nextStep)) {
                                        item.classList.remove(
                                            NAVIGATION_ACTIVE_CLASS,
                                        );
                                        item.classList.add(
                                            NAVIGATION_DONE_CLASS,
                                        );
                                    } else {
                                        item.classList.remove(
                                            NAVIGATION_ACTIVE_CLASS,
                                        );
                                    }
                                });
                            }
                        }
                    },
                );
            });
        });
    }
}

export function reportWizard(): void {
    $$(WIZARD_SELECTOR).map(
        (element: HTMLSelectElement): ReportWizard => {
            return new ReportWizard(element);
        },
    );
}
